// extracted by mini-css-extract-plugin
export default {"MoreIconContainer":"MoreDropdown_MoreIconContainer__X4thT","MoreContainer":"MoreDropdown_MoreContainer__pGyrK","Vertical":"MoreDropdown_Vertical__yhSa+"};